'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { useCache } from '@effektify/cache';
import { useRouter } from 'next/navigation';
import { useMemo, useState } from 'react';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { Dialog } from 'src/components/Molecules/Dialog';
import { ROUTES } from 'src/constants/routes';
import useUserDetails from 'src/hooks/useUserDetails';
import useTeams from 'src/hooks/useTeams';
import useRouteWithParams from 'src/hooks/useRouteWithParams';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { UserButtonWrapper, MenuContainer, MenuItemsWrapper, ChangeTeamIcon, ExpandIcon, LogoutIcon, MenuHeaderButton, MenuWrapper, Name, SettingsIcon, StyledAvatar, StyledList, StyledListItem, TeamOrDescription, UserDetails, UserItem, MenuListItem, IconContainer, AddTeamIcon } from './styled';
import useTranslations from 'src/hooks/useTranslations';
type DialogAction = 'logout' | 'changeTeam';
const dialogTypes = {
  logout: 'logout',
  changeTeam: 'changeTeam'
} as const;
const AccountMenu: React.FC<{
  isExpanded: boolean;
  expandSidebar: () => void;
}> = t0 => {
  const $ = _c(104);
  const {
    isExpanded: t1,
    expandSidebar
  } = t0;
  const isExpanded = t1 === undefined ? true : t1;
  const {
    t
  } = useTranslations();
  const router = useRouter();
  const {
    resetDataOnly
  } = useCache();
  const {
    updatePathWithParams
  } = useRouteWithParams();
  let t2;
  if ($[0] !== updatePathWithParams) {
    t2 = updatePathWithParams(ROUTES.SETTINGS);
    $[0] = updatePathWithParams;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const settingsRoute = t2;
  const {
    userDetails
  } = useUserDetails();
  const {
    currentTeam,
    teams
  } = useTeams();
  const [open, setOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogAction, setDialogAction] = useState(null);
  let t3;
  if ($[2] !== t) {
    t3 = t("components.menu.signoutTitle");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("components.menu.signoutDescription");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("common.cancel");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("components.menu.signoutButton");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = {
      cancel: t5,
      ok: t6
    };
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t7) {
    t8 = {
      title: t3,
      description: t4,
      actions: t7
    };
    $[13] = t3;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("components.menu.changeTeamTitle");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("components.menu.changeTeamDescription");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("common.cancel");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t("components.menu.changeTeamButton");
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12) {
    t13 = {
      cancel: t11,
      ok: t12
    };
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t10 || $[29] !== t13 || $[30] !== t9) {
    t14 = {
      title: t9,
      description: t10,
      actions: t13
    };
    $[28] = t10;
    $[29] = t13;
    $[30] = t9;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14 || $[33] !== t8) {
    t15 = {
      logout: t8,
      changeTeam: t14
    };
    $[32] = t14;
    $[33] = t8;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  const dialogDetails = t15;
  let t16;
  if ($[35] !== router) {
    t16 = () => {
      router.push(ROUTES.SIGNOUT);
    };
    $[35] = router;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const handleLogoutDialogClose = t16;
  let t17;
  if ($[37] !== resetDataOnly || $[38] !== router) {
    t17 = () => {
      resetDataOnly();
      router.push(ROUTES.SWITCH_COMPANY);
    };
    $[37] = resetDataOnly;
    $[38] = router;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  const handleSwitchCompany = t17;
  let t18;
  if ($[40] !== router || $[41] !== settingsRoute) {
    t18 = () => {
      router.push(settingsRoute);
    };
    $[40] = router;
    $[41] = settingsRoute;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  const handleGotoSettings = t18;
  let t19;
  if ($[43] !== router) {
    t19 = () => {
      router.push(ROUTES.CREATE_ADDITIONAL_TEAM);
    };
    $[43] = router;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  const handleAddTeam = t19;
  let t20;
  if ($[45] !== dialogDetails) {
    t20 = action => {
      if (action !== null && dialogDetails[action] || action !== "changeTeam") {
        setDialogAction(action);
        setDialogOpen(true);
      }
      setOpen(false);
    };
    $[45] = dialogDetails;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  const handleOpenDialog = t20;
  let t21;
  if ($[47] !== dialogAction || $[48] !== handleLogoutDialogClose) {
    t21 = result => {
      if (!dialogAction) {
        setDialogOpen(false);
        return;
      }
      if (result) {
        if (dialogAction === "logout") {
          handleLogoutDialogClose();
        }
        return;
      }
      setDialogOpen(false);
    };
    $[47] = dialogAction;
    $[48] = handleLogoutDialogClose;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  const handleCloseDialog = t21;
  const expandedClass = isExpanded ? "expanded" : "";
  let t22;
  if ($[50] !== t) {
    t22 = t("components.menu.menuItemSwitchCompany");
    $[50] = t;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <ChangeTeamIcon />;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== handleSwitchCompany) {
    t24 = () => handleSwitchCompany();
    $[53] = handleSwitchCompany;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  const t25 = teams && teams.length > 1;
  let t26;
  if ($[55] !== t22 || $[56] !== t24 || $[57] !== t25) {
    t26 = {
      name: t22,
      icon: t23,
      onPress: t24,
      renderAble: t25
    };
    $[55] = t22;
    $[56] = t24;
    $[57] = t25;
    $[58] = t26;
  } else {
    t26 = $[58];
  }
  let t27;
  if ($[59] !== t) {
    t27 = t("components.menu.menuItemAddTeam");
    $[59] = t;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <AddTeamIcon />;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== handleAddTeam) {
    t29 = () => handleAddTeam();
    $[62] = handleAddTeam;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== t27 || $[65] !== t29) {
    t30 = {
      name: t27,
      icon: t28,
      onPress: t29,
      renderAble: true
    };
    $[64] = t27;
    $[65] = t29;
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  let t31;
  if ($[67] !== t) {
    t31 = t("components.menu.menuItemSettings");
    $[67] = t;
    $[68] = t31;
  } else {
    t31 = $[68];
  }
  let t32;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <SettingsIcon />;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] !== handleGotoSettings) {
    t33 = () => handleGotoSettings();
    $[70] = handleGotoSettings;
    $[71] = t33;
  } else {
    t33 = $[71];
  }
  let t34;
  if ($[72] !== t31 || $[73] !== t33) {
    t34 = {
      name: t31,
      icon: t32,
      onPress: t33,
      renderAble: true
    };
    $[72] = t31;
    $[73] = t33;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  let t35;
  if ($[75] !== t) {
    t35 = t("components.menu.menuItemSignout");
    $[75] = t;
    $[76] = t35;
  } else {
    t35 = $[76];
  }
  let t36;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <LogoutIcon />;
    $[77] = t36;
  } else {
    t36 = $[77];
  }
  let t37;
  if ($[78] !== handleOpenDialog) {
    t37 = () => handleOpenDialog(dialogTypes.logout);
    $[78] = handleOpenDialog;
    $[79] = t37;
  } else {
    t37 = $[79];
  }
  let t38;
  if ($[80] !== t35 || $[81] !== t37) {
    t38 = {
      name: t35,
      icon: t36,
      onPress: t37,
      renderAble: true
    };
    $[80] = t35;
    $[81] = t37;
    $[82] = t38;
  } else {
    t38 = $[82];
  }
  let t39;
  if ($[83] !== t26 || $[84] !== t30 || $[85] !== t34 || $[86] !== t38) {
    t39 = [t26, t30, t34, t38];
    $[83] = t26;
    $[84] = t30;
    $[85] = t34;
    $[86] = t38;
    $[87] = t39;
  } else {
    t39 = $[87];
  }
  const MENU_ITEMS = t39;
  const t40 = dialogDetails[dialogAction as DialogAction];
  let t41;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <></>;
    $[88] = t41;
  } else {
    t41 = $[88];
  }
  let t42;
  if ($[89] !== dialogOpen || $[90] !== handleCloseDialog || $[91] !== t40) {
    t42 = <Dialog open={dialogOpen} {...t40} handleClose={handleCloseDialog}>{t41}</Dialog>;
    $[89] = dialogOpen;
    $[90] = handleCloseDialog;
    $[91] = t40;
    $[92] = t42;
  } else {
    t42 = $[92];
  }
  let t43;
  if ($[93] !== MENU_ITEMS || $[94] !== currentTeam || $[95] !== expandSidebar || $[96] !== expandedClass || $[97] !== isExpanded || $[98] !== open || $[99] !== userDetails) {
    t43 = userDetails && currentTeam && <ClickAwayListener onClickAway={() => setOpen(false)}><MenuWrapper className={`${expandedClass}`}><UserButtonWrapper><StyledList><StyledListItem key="account-menu-close"><LoggedInUserButton onButtonClick={() => {
                if (!isExpanded) {
                  expandSidebar();
                  setTimeout(() => {
                    setOpen(true);
                  }, 300);
                  return;
                }
                setOpen(!open && isExpanded);
              }} isExpanded={isExpanded} avatarUrl={userDetails.avatar_url} expandedClass={expandedClass} name={userDetails.name} teamName={currentTeam?.name || ""} /></StyledListItem></StyledList><MenuContainer className={isExpanded && open ? "showMenu" : ""}><MenuItemsWrapper><LoggedInUserButton onButtonClick={() => setOpen(!open && isExpanded)} isExpanded={isExpanded} avatarUrl={userDetails.avatar_url} expandedClass={expandedClass} name={userDetails.name} teamName={currentTeam?.name || ""} isListItem={true} />{MENU_ITEMS.map(_temp)}</MenuItemsWrapper></MenuContainer></UserButtonWrapper></MenuWrapper></ClickAwayListener>;
    $[93] = MENU_ITEMS;
    $[94] = currentTeam;
    $[95] = expandSidebar;
    $[96] = expandedClass;
    $[97] = isExpanded;
    $[98] = open;
    $[99] = userDetails;
    $[100] = t43;
  } else {
    t43 = $[100];
  }
  let t44;
  if ($[101] !== t42 || $[102] !== t43) {
    t44 = <>{t42}{t43}</>;
    $[101] = t42;
    $[102] = t43;
    $[103] = t44;
  } else {
    t44 = $[103];
  }
  return t44;
};
export default AccountMenu;
interface LoggedInUserButtonProps {
  onButtonClick: () => void;
  isExpanded: boolean;
  avatarUrl: string;
  expandedClass: string;
  name: string;
  teamName: string;
  isListItem?: boolean;
}
const LoggedInUserButton = t0 => {
  const $ = _c(27);
  const {
    onButtonClick,
    isExpanded,
    avatarUrl,
    expandedClass,
    name,
    teamName,
    isListItem: t1
  } = t0;
  const isListItem = t1 === undefined ? false : t1;
  const listItemClassName = isListItem ? "listItem" : "";
  let t2;
  if ($[0] !== avatarUrl) {
    t2 = <StyledAvatar src={avatarUrl} />;
    $[0] = avatarUrl;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== listItemClassName || $[3] !== name) {
    t3 = <Name className={listItemClassName}>{name}</Name>;
    $[2] = listItemClassName;
    $[3] = name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== listItemClassName || $[6] !== teamName) {
    t4 = <TeamOrDescription className={listItemClassName}>{teamName}</TeamOrDescription>;
    $[5] = listItemClassName;
    $[6] = teamName;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== expandedClass || $[9] !== t3 || $[10] !== t4) {
    t5 = <UserDetails className={expandedClass}>{t3}{t4}</UserDetails>;
    $[8] = expandedClass;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isExpanded || $[13] !== t5) {
    t6 = <Fade in={isExpanded} timeout={400} unmountOnExit={true}>{t5}</Fade>;
    $[12] = isExpanded;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t6) {
    t7 = <UserItem>{t2}{t6}</UserItem>;
    $[15] = t2;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== expandedClass || $[19] !== isExpanded || $[20] !== isListItem) {
    t8 = !isListItem && <Fade in={isExpanded} timeout={400} unmountOnExit={true}><ExpandIcon className={expandedClass} sx={{
        fontSize: 20
      }} /></Fade>;
    $[18] = expandedClass;
    $[19] = isExpanded;
    $[20] = isListItem;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== listItemClassName || $[23] !== onButtonClick || $[24] !== t7 || $[25] !== t8) {
    t9 = <MenuHeaderButton disableTouchRipple={true} onClick={onButtonClick} className={listItemClassName}>{t7}{t8}</MenuHeaderButton>;
    $[22] = listItemClassName;
    $[23] = onButtonClick;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
function _temp(item) {
  return item.renderAble && <MenuListItem key={item.name} onClick={item.onPress}><IconContainer className="iconContainer">{item.icon}</IconContainer><Typography variant="heading-sm" className="menuText" sx={{
      userSelect: "none",
      flex: 1
    }}>{item.name}</Typography></MenuListItem>;
}